import { ADD_POOLS, ADD_USER_PLEDGE, SET_ACTIVE_POOL, SET_CLOSED_POOLS, SET_LIVE_POOLS, UNSET_ACTIVE_POOL, UPDATE_CLOSED_POOLS, UPDATE_LIVE_POOLS, UPDATE_POOL_CONTRIBUTION, UPDATE_USER_PLEDGE } from "../action";

const PoolReducer = (state: any, action: any) => {
    switch(action.type) {
        case ADD_POOLS: {
            return {
                ...state,
                pools: [ ...state.pools, ...action.value ],
            }
        }
        case UPDATE_POOL_CONTRIBUTION: {
            return {
                ...state,
                poolProgress: [ ...state.poolProgress, { poolId: action.value.poolId, progress: { cap: action.value.cap, amount: action.value.amount }}]
            }
        }
        case UPDATE_USER_PLEDGE: {
            return {
                ...state,
                userPledges: action.value,
            }
        }
        case ADD_USER_PLEDGE: {
            return {
                ...state,
                userPledges: [ ...state.userPledges, action.value ],
            }
        }
        case SET_ACTIVE_POOL: {
            localStorage.setItem("activePool", JSON.stringify(action.value));
            return {
                ...state,
                activePool: action.value,
            }
        }

        case UNSET_ACTIVE_POOL: {
            localStorage.removeItem("activePool")!;
            return {
                ...state,
                activePool: null,
            }
        }

        case SET_LIVE_POOLS: {
            return {
                ...state,
                livePools: action.value,
            }
        }

        case UPDATE_LIVE_POOLS: {
            const updatedPools = [ ...state.livePools, action.data ].reduce((accumulator, current) => {
                if (!accumulator.some((item: any) => item.id === current.id)) {
                    accumulator.push(current)
                }
                return accumulator;
            }, []);
            return {
                ...state,
                livePools: updatedPools
            }
        }

        case UPDATE_CLOSED_POOLS: {
            const updatedPools = [ ...state.closedPools, action.data ].reduce((accumulator, current) => {
                if (!accumulator.some((item: any) => item.id === current.id)) {
                    accumulator.push(current)
                }
                return accumulator;
            }, []);
            return {
                ...state,
                closedPools: updatedPools,
            }
        }

        case SET_CLOSED_POOLS: {
            return {
                ...state,
                closedPools: action.value,
            }
        }
                
    }
}

export default PoolReducer;